import { useState } from 'react';
import { Link } from 'react-router-dom';
import { EnvelopeIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { Button, Input } from '../../../components';
import { useAuth } from '../hooks/useAuth';

export default function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<{ email?: string; password?: string }>({});

  const { login, isLoading } = useAuth();

  const validateForm = () => {
    const newErrors: { email?: string; password?: string } = {};

    if (!email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Please enter a valid email';
    }

    if (!password) {
      newErrors.password = 'Password is required';
    } else if (password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) return;

    login({ email, password });
  };

  return (
    <div className="w-full max-w-md">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-ink font-display">Welcome back</h1>
        <p className="mt-2 text-sm text-ink-2">
          Sign in to access the customer support dashboard
        </p>
      </div>

      <form onSubmit={handleSubmit} className="mt-8 space-y-6">
        <Input
          type="email"
          label="Email address"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={errors.email}
          leftIcon={<EnvelopeIcon className="h-5 w-5" />}
          autoComplete="email"
          autoFocus
        />

        <Input
          type="password"
          label="Password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={errors.password}
          leftIcon={<LockClosedIcon className="h-5 w-5" />}
          autoComplete="current-password"
        />

        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <input
              id="remember-me"
              name="remember-me"
              type="checkbox"
              className="h-4 w-4 rounded border-line bg-surface text-brand focus:ring-brand"
            />
            <label htmlFor="remember-me" className="ml-2 block text-sm text-ink-2">
              Remember me
            </label>
          </div>

          <Link
            to="/forgot-password"
            className="text-sm font-medium text-brand hover:text-brand-ink"
          >
            Forgot password?
          </Link>
        </div>

        <Button type="submit" className="w-full" isLoading={isLoading}>
          Sign in
        </Button>

        <p className="text-center text-sm text-ink-2">
          Don't have an account?{' '}
          <Link to="/register" className="font-medium text-brand hover:text-brand-ink">
            Sign up
          </Link>
        </p>
      </form>
    </div>
  );
}
